// Note:
// _menu: nếu là các menu
// _act: nếu là các action của button, ...

export const GlobalPolcies = {
  productModule: {
    list: {
      shareButton: 9865,
      notifyButton: 9865
    },
    navigator: 9865
  },
  userModule: {
    list: {

    },
    navigator: 9865
  },
  khenThuongKyLuat: {
    left_menu: {
      trang_chu: '',
      khen_thuong_ky_luat: '1208', //web: menu left - Khen thưởng kỷ luật v2 - Quản Lý
      khen_thuong_ky_luat_menu: {
        trang_chu: '1218', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Trang chủ
        quan_ly_cap_khoa: '1209', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp khoa
        quan_ly_cap_khoa_menu: {
          quan_ly_ky_luat: '1219', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp khoa - Quản lý kỷ luật
          quan_ly_khen_thuong: '1220' //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp khoa - Quản lý khen thưởng
        },
        quan_ly_cap_truong: '1210', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường
        quan_ly_cap_truong_menu: {
          quan_ly_ky_luat: '1221', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường - Quản lý kỷ luật
          quan_ly_khen_thuong: '1222' //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường - Quản lý khen thưởng
        },
        quan_ly_phan_quyen: '1211', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý phân quyền
        quan_ly_thong_ke: '1233', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Quản lý thống kê
        huong_dan_su_dung: '1212', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Hướng dẫn sử dụng
        import_du_lieu: '1217', //web: menu left - Khen thưởng kỷ luật v2 - Quản lý - Import dữ liệu
      },
      khen_thuong_ky_luat_sinh_vien: '1207', //web: menu left - Khen thưởng kỷ luật v2 - Sinh viên
    },
    chi_tiet_kltkl: {
      tac_vu_cap_truong_act: '1213', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường - Tác vụ thông tin chi tiết
      tac_vu_cap_khoa_act: '1214', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp khoa - Tác vụ thông tin chi tiết
    },
    danh_sach_quan_ly: {
      cap_truong: {
        ky_luat: {
          tac_vu_excel_act: '1227', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường - Quản lý kỷ luật - Tác vụ excel
          tac_vu_khac_act: '1228', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường - Quản lý kỷ luật - Tác vụ khác
        },
        khen_thuong: {
          tac_vu_excel_act: '1229', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường - Quản lý khen thưởng - Tác vụ excel
          tac_vu_khac_act: '1230', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp trường - Quản lý khen thưởng - Tác vụ khác
        }
      },
      cap_khoa: {
        ky_luat: {
          tac_vu_khac_act: '1231', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Quản lý cấp khoa - Quản lý kỷ luật - Tác vụ khác
        },
      }
    },
    dashboard_act: {
      bieu_do_bien_dong_ky_luat: '1223', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Trang chủ  - Biểu đồ biến động kỷ luật
      bieu_do_bien_dong_khen_thuong: '1224', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Trang chủ  - Biểu đồ biến động khen thưởng
      bieu_do_ty_le_ky_luat: '1225', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Trang chủ  - Biểu đồ tỷ lệ kỷ luật
      bieu_do_ty_le_khen_thuong: '1226', //web: action - Khen thưởng kỷ luật v2 - Quản lý - Trang chủ  - Biểu đồ tỷ lệ khen thưởng
    }
  },
  ticketManagementModule: {
    left_menu: {
      trang_chu: '',
      yeu_cau_ho_tro: '5288', //web: menu left - Tickets - Yêu cầu hỗ trợ (BETA 1285→5288)
      yeu_cau_ho_tro_menu: {
        sinh_vien_menu: {
          tao_cau_hoi: '5289', //web: menu left - Tickets - Sinh viên - Tạo câu hỏi (BETA 1286→5289)
          cau_hoi_da_gui: '5290'  //web: menu left - Tickets - Sinh viên - Câu hỏi đã gửi (BETA 1287→5290)
        },
        quan_ly_menu: {
          cau_hoi: '5292', //web: menu left - Tickets - Quản lý - Câu hỏi (BETA 1288→5292)
          feedback: '5293', //web: menu left - Tickets - Quản lý - Feedback (BETA 1289→5293)
          thong_ke: '5291', //web: menu left - Tickets - Quản lý - Dashboard (BETA 1307→5291)
          cai_dat: '5294', //web: menu left - Tickets - Quản lý - Cài đặt (BETA 1290→5294)
          cai_dat_menu: {
            tai_khoan: '5295', //web: menu left - Tickets - Quản lý - Cài đặt - Tài khoản (BETA 1291→5295)
            don_vi: '5296', //web: menu left - Tickets - Quản lý - Cài đặt - Đơn vị (BETA 1292→5296)
            don_vi_ho_tro: '5297', //web: menu left - Tickets - Quản lý - Cài đặt - Đơn vị hỗ trợ (BETA 1293→5297)
            loai_ticket: '5298', //web: menu left - Tickets - Quản lý - Cài đặt - Loại ticket (BETA 1294→5298)
            key_cham_soc: '5299', //web: menu left - Tickets - Quản lý - Cài đặt - Key chăm sóc (BETA 1295→5299)
            ho_tro_tu_dong: '5300', //web: menu left - Tickets - Quản lý - Cài đặt - Hỗ trợ tự động (BETA 1296→5300)
            knowledge: '5301', //web: menu left - Tickets - Quản lý - Cài đặt - Knowledge (BETA 1297→5301)
          }
        }
      }
    },
    quan_ly_act: {
      summary_act: {
        tickets: '5313', //web: menu left - Tickets - Quản lý - Xem tổng quan số lượng câu hỏi (BETA 1298→5313)
        tickets_act: {
          doi_tiep_nhan: '1299', //web: action - Tickets - Quản lý - Đợi tiếp nhận
          da_tra_loi: '1300', //web: action - Tickets - Quản lý - Đã trả lời
          sinh_vien_da_dong: '1301', //web: action - Tickets - Quản lý - Sinh viên đã đóng
          he_thong_dong_co_de_nghi: '1302', //web: action - Tickets - Quản lý - Hệ thống đóng có đề nghị
          he_thong_dong_khong_phan_hoi: '1303', //web: action - Tickets - Quản lý - Hệ thống đóng không phản hôi
          da_tiep_nhan: '1304', //web: action - Tickets - Quản lý - Đã tiếp nhận
          cho_phan_hoi: '1305' //web: action - Tickets - Quản lý - Chờ phản hồi
        }
      }
    },
    feedback_act: {
      summary_act: '5314'  //web: menu left - Tickets - Feedback - Xem tổng quan đánh giá (BETA 1306→5314)
    }
  },
  htptdtdonphieuonlineModule: {
    left_menu: {
      dang_ky: '1319', //web: menu left - Đơn phiếu Online HTPTĐT - Đăng ký (BETA 1319→5330)
    }
  },
  elearning_v2: {
    left_menu: {
      trang_chu: '5041', // web: menu left - Elearning v2 - Dashboard (KHÔNG có trong sheet BETA — giữ nguyên)
      /**
       * Nhóm Học vụ (sinh viên) — ID mới theo sheet BETA "3.Menu - DICH VU".
       * Thay cho MenuAuthen.WEB_HTDN_MLEFT_ELEARNING_SINGVIEN_* (hệ cũ 690–695).
       */
      hoc_vu: '5356',              //web: menu left - ELEARNING V2 - Học vụ (menu cha) — thay MenuAuthen.WEB_MLEFT_HOC_TAP (695)
      hoc_vu_menu: {
        thoi_khoa_bieu: '5357',    //web: menu left - ELEARNING V2 - Học vụ - Thời khóa biểu — thay 693 · /elearning/thoi-khoa-bieu/sinh-vien
        lop_hoc_phan: '5358',      //web: menu left - ELEARNING V2 - Học vụ - Lớp học phần   — thay 690 · /elearning/lop-hoc-phan/sinh-vien
        lich_thi: '5359',          //web: menu left - ELEARNING V2 - Học vụ - Lịch thi       — thay 691 · /elearning/hoc-vu/lich-thi
        xem_diem: '5360',          //web: menu left - ELEARNING V2 - Học vụ - Xem điểm       — thay 692 · /elearning/hoc-vu/xem-diem
      },
    }
  },
  ho_so_ca_nhan_v2: {
    left_menu: {
      ho_so_ca_nhan_v2: '5131', // web: menu left - Hồ sơ cá nhân v2
    },
    actions: {
      print: {
        thong_tin_sinh_vien_pdf: '5144'
      }
    }

  }
}

